import { z } from 'zod';
import { EmailSchema, HistoryEntrySchema, IDSchema, IsoTimestampSchema, SchemaVersionSchema, } from './shared.js';
export const TaskStateSchema = z.enum(['open', 'completed', 'canceled']);
export const TaskSchema = z.object({
    id: IDSchema,
    type: z.literal('task'),
    schemaVersion: SchemaVersionSchema,
    accountId: IDSchema,
    title: z.string().min(1),
    description: z.string().optional(),
    assigneeEmail: EmailSchema,
    dueAt: IsoTimestampSchema.optional(),
    reminderAt: IsoTimestampSchema.optional(),
    state: TaskStateSchema.default('open'),
    completedAt: IsoTimestampSchema.optional(),
    completedBy: z.string().optional(),
    relatedDealId: IDSchema.optional(),
    relatedMeetingId: IDSchema.optional(),
    reminderFiredAt: IsoTimestampSchema.optional(),
    /** T9-006 — stamped when the 24h-before-due-at reminder cron fires. */
    dueSoonReminderFiredAt: IsoTimestampSchema.optional(),
    /** T9-006 — stamped when the post-due-at overdue reminder cron fires. */
    overdueReminderFiredAt: IsoTimestampSchema.optional(),
    // RIG-336 — uses the shared HistoryEntrySchema (payload omitted: this entity
    // intentionally does not record structured history payloads).
    history: z.array(HistoryEntrySchema.omit({ payload: true })).default([]),
    createdAt: IsoTimestampSchema,
    createdBy: z.string(),
    updatedAt: IsoTimestampSchema,
    updatedBy: z.string(),
    deletedAt: IsoTimestampSchema.nullable().optional(),
    /** QA 2026-10-01 F-42: deleted together with its account (restore brings it back). */
    deletedByCascade: z.boolean().default(false),
    version: z.number().int().positive(),
});
//# sourceMappingURL=task.js.map